import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "../screens/User/Home/Home.css";
import Typed from "react-typed";
import PropTypes from "prop-types";
import "bootstrap/dist/css/bootstrap.css";
import malaysiaFlag from "../images/malaysiaf.png";
import moroccoFlag from "../images/Morocco-Flag-icon.png";
import franceFlag from "../images/1466924.png";
import leftArrow from "../images/chevron-left.svg";
import rightArrow from "../images/chevron-right.svg";
const ThirdSection = () => {
  return (
    <div class="py-5">
      <div class="container text-center">
        <h1
          className="text-center"
          style={{ color: "rgb(118, 102, 223)", fontSize: 50 }}
        >
          <i class="fas fa-quote-left"></i> Testimonials
        </h1>
        <p class="lead mb-5">
        Nothing can be better than getting a review from our happy clients who recommend us and trust us their business.
          </p>
        <div class="row">
          <div
            class="carousel slide my-4"
            id="carousel-testimonials-02"
            data-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <div class="row">
                  <div class="col-md-12 mt-5">
                    <p class="mb-4" style={{ fontSize: "1.5rem" }}>
                      It was a great pleasure to work with Adnan. He delivered
                      the work at time, sometimes before the convenient time.
                      Adnan is an easy person to work with and tallented to
                      deliver the require product in respect of quality, budget
                      and deadline. I highly recommand Adnan for mobile app
                      developement.
                    </p>
                    <img
                      class="mx-auto "
                      src={moroccoFlag}
                      alt=""
                      style={{ height: "5rem", width: "5rem" }}
                    />
                    <p class="mt-4 mb-0">mohamedsrhayri</p>
                    <p class="text-muted">Morocco | Fiverr User</p>
                  </div>
                </div>
              </div>
              <div class="carousel-item">
                <div class="row">
                  <div class="col-md-12 mt-5">
                    <p class="mb-4" style={{ fontSize: "2.5rem" }}>
                      Ontime seller response, very satisfied with it. happy to
                      collaborate with this gig
                    </p>
                    <img
                      class="mx-auto"
                      //   src={malaysiaf}
                      src={malaysiaFlag}
                      alt=""
                      style={{ height: "7rem", width: "6rem" }}
                    />
                    <p class="mt-4 mb-0">alazimariff</p>
                    <p class="text-muted">Malaysia | Fiverr User</p>
                  </div>
                </div>
              </div>
              <div class="carousel-item ">
                <div class="row">
                  <div class="col-md-12 mt-5">
                    <p class="mb-4" style={{ fontSize: "2.5rem" }}>
                      It is a pleasure to work with you. I hope we keep in
                      touch. good work 👍
                    </p>
                    <img
                      class="mx-auto"
                      //   src={malaysiaf}
                      src={franceFlag}
                      alt=""
                      style={{ height: "4rem", width: "6rem" }}
                    />
                    <p class="mt-4 mb-0">Mouad Belkziz</p>
                    <p class="text-muted">Rouen France | France User</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mx-auto">
            <a
              class="carousel-control-prev position-relative d-inline mr-2"
              href="#carousel-testimonials-02"
              role="button"
              data-slide="prev"
            >
              <img src={leftArrow} aria-hidden="true" alt="" />
              <span class="sr-only">Previous</span>
            </a>
            <a
              class="carousel-control-next position-relative d-inline"
              href="#carousel-testimonials-02"
              role="button"
              data-slide="next"
            >
              <img src={rightArrow} aria-hidden="true" alt="" />
              <span class="sr-only">Next</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
// }

ThirdSection.propTypes = {
  fluid: PropTypes.bool,
  // applies .container-fluid className
};

export default withRouter(ThirdSection);
